var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("Generating PDF...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.errorMessage))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }